<script>
import EllipsisLoader from './ellipsis';

export const Ellipsis = EllipsisLoader;
export default {
    setup() {
        
    },
}
</script>